import { Navigate, useLocation } from 'react-router-dom';

import { useAuthStore } from '@/entities/auth';

import { IS_DEMO_APP_MODE } from '@/features/auth/lib/demoAuth';
import { DirectLoginModal } from '@/features/auth/ui/DirectLoginModal';

export const DemoLoginPage: React.FC = () => {
  const location = useLocation();
  const { user, isAuthenticated } = useAuthStore();

  const from =
    typeof location.state === 'object' && location.state !== null && 'from' in location.state
      ? String((location.state as { from?: string }).from ?? '/')
      : '/';

  const redirectTo = from.startsWith('/') && !from.startsWith('/login') ? from : '/';

  if (!IS_DEMO_APP_MODE) {
    return <Navigate to="/" replace />;
  }

  if (isAuthenticated && user) {
    return <Navigate to={redirectTo} replace />;
  }

  return <DirectLoginModal open={true} />;
};
